/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// src/utils/offlineLpoStore.js
import { openDB } from 'idb';

const DB_NAME = 'fluxonix-offline-lpo';
const STORE_NAME = 'lpo-entries';

// 📦 Initialize IndexedDB store
async function getDb() {
  return await openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
    },
  });
}

// ✅ Save a new offline entry (voice + photos + formData)
export async function saveLpoOffline({ voiceBlob, photoBlobs = [], formData = {}, timestamp }) {
  console.log("📦 [offlineLpoStore] saving offline LPO to IndexedDB");
  const db = await getDb();
  await db.add(STORE_NAME, {
    voiceBlob,
    photoBlobs,
    formData,
    timestamp: timestamp || new Date().toISOString(),
  });
}

// 📥 Get all offline entries
export async function getAllLpoEntries() {
  const db = await getDb();
  const tx = db.transaction(STORE_NAME, 'readonly');
  const store = tx.objectStore(STORE_NAME);
  const allEntries = await store.getAll();
  return allEntries.map((entry, index) => ({ ...entry, id: entry.id ?? index }));
}

// ❌ Remove an entry by its ID
export async function removeLpoEntry(id) {
  const db = await getDb();
  await db.delete(STORE_NAME, id);
}

// 🔄 Clear all entries (optional helper)
export async function clearAllLpoEntries() {
  const db = await getDb();
  await db.clear(STORE_NAME);
}